import type { CSSProperties } from 'react';

import classNames from 'classnames';

import { mediaTypeIcon } from '@iconik-io/shared-lib/src/utils/media_icon_type';
import { Icon } from '@iconik-io/uad';

import type { ObjectIconInfo } from '../../utils/parse_object_icon_info';

import mixins from '../../styles/core/mixins.module.css';
import styles from './object_icon.module.css';

type Props = {
  info: ObjectIconInfo;
  className?: string;
  size?: number;
  textAlign?: boolean;
};

export function ObjectIcon({ info, size, className, textAlign }: Props) {
  if ('type' in info) {
    return (
      <Icon
        name={mediaTypeIcon[info.type]}
        className={classNames(
          className,
          styles.icon,
          textAlign && mixins.text_align_icon,
        )}
        style={{ width: size, height: size }}
      />
    );
  }

  if ('format' in info) {
    const scaleFactor = size ? size / 20 : 1;

    const borderWidth = scaleFactor;
    const inlineStyles = {
      borderWidth: `${borderWidth * 1.5}px`,
      padding: `0 ${2 * scaleFactor}px`,
      borderRadius: `${0.7 * scaleFactor}px`,
      fontSize: `${8 * scaleFactor}px`,
      lineHeight: `${12.7 * scaleFactor}px`,
    };

    const wrapperStyles: CSSProperties = {};
    if (size) {
      wrapperStyles.height = `${size}px`;
      wrapperStyles.lineHeight = `${size - borderWidth * 2}px`;
    }

    return (
      <span className={className} style={wrapperStyles}>
        <span className={styles.icon_format_label} style={inlineStyles}>
          {info.format}
        </span>
      </span>
    );
  }

  return null;
}
